import React from 'react';

// Presentational Review screen for Edit. All content comes from buildChangeSet(); no API calls.
export default function CompanyReview({ changeSet, onBack, onConfirm, saving = false }) {
  const groups = (changeSet?.groups || [])
    .map((g) => ({ ...g, rows: g.rows.filter((r) => r.changed) }))
    .filter((g) => g.rows.length > 0);
  const effects = changeSet?.effects || [];

  return (
    <div className="cmp-review">
      {groups.length === 0 && (
        <div className="cmp-review-empty">
          <small className="text-muted">No changes</small>
        </div>
      )}

      {groups.map((g) => (
        <div className="cmp-review-group" key={g.group}>
          <h6 className="cmp-review-group-title">{g.group}</h6>
          {g.rows.map((r) => {
            const format = r.format || ((v) => String(v ?? ''));
            return (
              <div className="cmp-review-row" key={r.key}>
                <span className="cmp-review-label">{r.label}:</span>
                <span className="cmp-review-values">
                  <span className="cmp-review-from">{format(r.from)}</span>
                  <span className="cmp-review-arrow"> {'→'} </span>
                  <span className="cmp-review-to">{format(r.to)}</span>
                </span>
              </div>
            );
          })}
        </div>
      ))}

      {effects.length > 0 && (
        <div className="cmp-review-effects">
          <h6 className="cmp-review-group-title">What will happen</h6>
          <ul>
            {effects.map((effect, index) => (
              <li key={index} className={`cmp-effect cmp-effect--${effect.level}`}>
                {effect.level === 'warning' ? (
                  <i className="fa fa-exclamation-triangle text-warning mr-2"></i>
                ) : (
                  <i className="fa fa-info-circle text-info mr-2"></i>
                )}
                <span>{effect.text}</span>
              </li>
            ))}
          </ul>
        </div>
      )}

      <div className="cmp-review-actions">
        {/* btn-outline-*: the global .btn-primary override in PricingConfig.css changes its size. */}
        <button type="button" className="btn btn-outline-secondary mr-2" onClick={onBack} disabled={saving}>
          Back to edit
        </button>
        <button type="button" className="btn btn-outline-primary" onClick={onConfirm} disabled={saving}>
          {saving && <i className="fa fa-spinner fa-spin mr-2"></i>}
          Save changes
        </button>
      </div>
    </div>
  );
}
